export default __webpack_public_path__ + "static/media/Fiona Ma.f06ae1f5.jpg";